import { connect } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import { DashboardRoute, Login } from './routes';
import './App.css';

function App({ ctrl, token }) {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/dashboard/*"
            element={
              <PrivateRoute>
                <DashboardRoute token={token} />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

const mapStateToProps = (state) => ({
  token: state.app.user.token,
});
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(App);
